
export const cps = (state = { 
        showLevels: false,
        isLoading: false,
        options: [
                { 'key':0,iconProps: { iconName: 'BarChartVertical' }, 'text' : '0 Never'},
                { 'key':1,iconProps: { iconName: 'BarChartVertical' }, 'text' : '1 Rarely'},
                { 'key':2,iconProps: { iconName: 'BarChartVertical' }, 'text' : '2 Sometimes'},
                { 'key':3,iconProps: { iconName: 'BarChartVertical' }, 'text' : '3 Quite Often'},
                { 'key':4,iconProps: { iconName: 'BarChartVertical' }, 'text' : '4 Almost Always'},
                { 'key':5,iconProps: { iconName: 'BarChartVertical' }, 'text' : '5 Always'},
                { 'key':'NEK',iconProps: { iconName: 'BarChartVertical' }, 'text' : 'NEK'}
            ]
    }, action) => {
    switch(action.type) {
        case 'FETCH_REQUEST':
            return { ...state,isLoading: true }
        case 'FETCH_SUCCESS':
            //TODO count indicators in cps 
            return {...state, cps: action.cps, answers: action.answers, isLoading: false }
        case 'FETCH_ERROR':
            return { ...state,message: 'Unable to fetch data', err: action.err, isLoading: false }
        case 'RATING':
            const answers = state.answers.slice(0);
            answers[action.cpIndex][action.levelIndex][action.index] = action.value;
            return { ...state, answers: answers};
        case 'CHANGE_ANSWER':
            return { ...state, answers: action.answers}
        default:
            return state;
    }
};





// WEBPACK FOOTER //
// ./src/examples/cps/reducers.js